import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { PipesModule } from '../../pipes/pipes.module';
import { GridModule } from '../grid/grid.component.module';
import { ObjectBrowserModule } from '../object-browser';
import { JobSiteDetailComponent } from './job-site-detail.component';

@NgModule({
    declarations: [JobSiteDetailComponent],
    exports: [JobSiteDetailComponent],
    imports: [TwcModule, TranslateModule, GridModule, ObjectBrowserModule, PipesModule],
})
export class JobSiteDetailModule {}
